import { render } from "./AppLogo.vue?vue&type=template&id=2acd1e96"
import script from "./AppLogo.vue?vue&type=script&lang=ts"
export * from "./AppLogo.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./AppLogo.vue?vue&type=style&index=0&id=2acd1e96&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script